import { dashboardClickDeleteNote } from '@/modules/dashboard/dashboardActions';
import { useDispatch } from 'react-redux';

export const useRemoveNoteMutation = () => {
	const dispatch = useDispatch();

	const mutate = () => {
		dispatch(dashboardClickDeleteNote());
	};

	return { mutate };
};
